<template>
  <div>
    <Table :columns="columns" :data="resources" size="small" highlight-row stripe max-height="700">
      <template slot-scope="{ row }" slot="barcode">
        <span>
          {{ row.product ? row.product.barcode : 'N/A' }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="product">
        <span>
          {{ row.product ? row.product.product_name_en : 'N/A' }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="uom">
        <span>
          {{ row.unite_of_measure ? row.unite_of_measure.uom_name_en : 'N/A' }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="cost">
        <ts-display-currency :amount="row.input_cost" :currency_id="row.input_currency_id" />
      </template>
      <template slot-scope="{ row }" slot="discount">
        <b class="ts-text-blue-700" v-if="row.discount_type == '%'">
          {{ row.discount_rate + ' ' + row.discount_type }}
        </b>
        <div v-else>
          <ts-display-currency :amount="row.input_discount_rate" :currency_id="row.input_currency_id" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="fx_rate">
        <div class="text-right ts-text-blue-700 ts-font-semibold">
          {{ row.fx_rate }}
        </div>
      </template>
      <template slot-scope="{ row }" slot="total">
        <ts-display-currency :amount="row.input_total_after_discount" :currency_id="row.input_currency_id" />
      </template>
      <template slot-scope="{ row }" slot="converted_total">
        <ts-display-currency :amount="row.total_after_discount" :currency_id="row.currency_id" />
      </template>
      <template slot-scope="{ row }" slot="max_reorder">
        {{
          row.product.maximum_reorder_allow
            ? row.product.maximum_reorder_allow
            : 0
        }}
      </template>
      <template slot-scope="{ row }" slot="allow_order">
        <span class="badge badge-success" v-if="
          row.quantity_order >
          (row.product.maximum_reorder_allow
            ? row.product.maximum_reorder_allow
            : 0)
        ">Yes</span>
        <span class="badge badge-danger" v-else>No</span>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  name: 'tableExpand',
  props: {
    row: Object
  },
  data() {
    return {}
  },
  computed: {
    resources() {
      return this.row.details
    },
    columns() {
      return [
        {
          title: this.$t('purchaseOrder.barcode'),
          slot: 'barcode',
          minWidth: 90,
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.productName'),
          slot: 'product',
          minWidth: 180,
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.uom'),
          slot: 'uom',
          minWidth: 70,
          align: 'center'
        },
        {
          title: this.$t('purchaseOrder.quantityOrder'),
          key: 'quantity_order',
          minWidth: 130,
          sortable: true,
          align: 'center'
        },
        {
          title: this.$t('purchaseOrder.quantityReceived'),
          key: 'quantity_received',
          minWidth: 130,
          sortable: true,
          align: 'center'
        },
        {
          title: this.$t('purchaseOrder.cost'),
          slot: 'cost',
          minWidth: 120,
          sortable: true,
          align: 'right'
        },
        {
          title: this.$t('purchaseOrder.discount'),
          slot: 'discount',
          minWidth: 120,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.amount'),
          slot: 'total',
          minWidth: 120,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.convertedAmount'),
          slot: 'converted_total',
          minWidth: 150,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.maxReorder'),
          slot: 'max_reorder',
          minWidth: 130,
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.alloworder'),
          slot: 'allow_order',
          minWidth: 130,
          align: 'center',
          sortable: true
        }
      ]
    }
  },
  methods: {}
}
</script>
